import { render } from "./FormInputText.vue?vue&type=template&id=ea70f9fc"
import script from "./FormInputText.vue?vue&type=script&lang=js"
export * from "./FormInputText.vue?vue&type=script&lang=js"

import "./FormInputText.vue?vue&type=style&index=0&id=ea70f9fc&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__